import { useAdminProfiles } from '@/hooks/useAdminDirectory'
import { AdminProfileList } from './AdminProfileList'
import { sectionStyle, sectionTitleStyle, pageTitleStyle, pageSubtitleStyle } from './adminListStyles'

export default function AdminInstructors() {
  const { profiles, loading, updating, setAccountStatus } = useAdminProfiles()
  const instructors = profiles.filter(p => p.primaryRole === 'instructor')

  return (
    <div style={{ maxWidth: 900 }}>
      <div style={pageTitleStyle}>Instructors</div>
      <div style={pageSubtitleStyle}>
        Every instructor account on the platform, independent/private and school-affiliated alike.
      </div>

      <div style={sectionStyle}>
        <div style={sectionTitleStyle}>Instructors ({instructors.length})</div>
        <AdminProfileList profiles={instructors} loading={loading} updating={updating} onSetStatus={setAccountStatus} />
      </div>
    </div>
  )
}
